export default "__VITE_ASSET__BgHg$Nqp__"